import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { from, until } from '@guardian/source-foundations';
const hideBelowDesktop = css `
	${until.desktop} {
		/* below 980 */
		display: none;
	}

	${from.desktop} {
		/* above 980 */
		height: 100%;
		display: block;
		flex-basis: 300px;
		flex-grow: 0;
		flex-shrink: 0;
	}
`;
export const RightColumn = ({ children }) => {
    return _jsx("section", Object.assign({ css: hideBelowDesktop }, { children: children }), void 0);
};
